// @flow
import styled from 'styled-components';
import {
  textSemiBold,
  textNormal,
  textBlack,
  textBold,
  textBoldLoose,
} from './css';
import { Text9 } from './Text';

export const Text9Normal = styled(Text9)`
  ${textNormal};
`;

export const Text9Black = styled(Text9)`
  ${textBlack};
`;

export const Text9SemiBold = styled(Text9)`
  ${textSemiBold};
`;

export const Text9Bold = styled(Text9)`
  ${textBold};
`;

export const Text9BoldLoose = styled(Text9)`
  ${textBoldLoose};
`;
